import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"float":"right"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Tokens")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Holders")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Transactions")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("LogEvents")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Identitys")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Clear")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = { style: {"float":"right"} }

import { ref } from "vue"

// import { Resolution } from '@unstoppabledomains/resolution';

import * as tools from "../libs/tools"
import * as connect from "../libs/connect"
import * as network from "../libs/network"
import * as element from "../libs/element"

import * as constant from "../constant"

  
const __default__ = {
  name: 'NavBar',
  props: {
  },
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const logo = require('@/assets/logo.png');
const metamask = require('@/assets/metamask.svg');
// const resolution = new Resolution();
const userName = connect.connectState.userName;
const shortName = connect.connectState.shortName;
const userAddr = connect.connectState.userAddr;
const shortAddr = connect.connectState.shortAddr;
const networkName = ref("");
const searchContent = ref("");
const activeIndex = connect.connectState.activeIndex;
const connectStatus = ref("Connect Wallet");
const transactions = connect.connectState.transactions;
const transactionCount = connect.connectState.transactionCount;

//transaction explore url
const transactionExplorerUrl = (transaction:string) => {
  for(const i in constant.chainList){
    if(connect.connectState.chainId === constant.chainList[i].chainId){
      const blockExplorerUrls = constant.chainList[i].blockExplorerUrls;
      return blockExplorerUrls + '/tx/' + transaction;
    }
  }

  return transaction;
}

//connect to metamask
const connectNetwork = async () => {
  await connect.networkConnect().then(async (res) => {
    if(res){
      element.elMessage('success', 'You have connected to the wallet.');
    }else{
      await connect.cancelConnect();
      userAddr.value = "";
      shortName.value = "";
      shortAddr.value = "";
      networkName.value = "";
      connectStatus.value = "Connect Wallet";

      element.elMessage('error', 'Connect to the wallet failed.');  
    }
         
  });
}

//set connect callback function
connect.connectState.connectCallback = async () => {
    userName.value = connect.connectState.userName.value;
    shortName.value = tools.shortString(userName.value);
    userAddr.value = connect.connectState.userAddr.value;
    shortAddr.value = tools.shortString(userAddr.value);

    networkName.value = network.getChainName(connect.connectState.chainId);
    connectStatus.value = "Cancel Connect";  
};

//disconnect from metamask
const disConnectNetwork = async () => {
    await connect.cancelConnect();

    connectStatus.value = "Connect Wallet";
    userName.value = "";
    shortName.value = "";
    userAddr.value = "";
    shortAddr.value = "";
    networkName.value = "";

    element.elMessage('warning', 'You have disconnected to the wallet.');                     
}

//on wallet address changed
const accountsChanged = async (accounts: string[]) => {
  if(accounts.length === 0){
    return await disConnectNetwork();
  }

  if(connectStatus.value === "Cancel Connect"){
    await connectNetwork();
    connect.connectState.searchCallback();
  }
}

connect.connectState.accountsChanged = accountsChanged;

//on wallet network changed
const chainChanged = async () => {
  //clear transactions when network changed
  connect.connectState.transactions.value = new Array();
  connect.connectState.transactionCount.value = 0;

  if(!(await connect.connected())){
    return;
  }

  if(connectStatus.value === "Cancel Connect"){
    await connect.connectState.connectCallback();
    connect.connectState.searchCallback();
  } 
}

connect.connectState.chainChanged = chainChanged;

//on click to clear transtractions
const onClearTransactions = async () => {
  connect.connectState.transactions.value = new Array();
  connect.connectState.transactionCount.value = 0; 
}

//on click to copy address
const onClickToCopy = async (content:string) => {
  tools.clickToCopy(content);
  
  element.elMessage('success', 'Copy ' + content + ' to clipboard success.');     
};

//on click notify
const onClickNotify = async () => {
  transactionCount.value = 0;
}

//on content search
const onSearchContent = async () => {
  connect.connectState.search = searchContent.value.trim();
  await connect.connectState.searchCallback();
  searchContent.value = '';
  connect.connectState.search = '';
}

//on connect clicked
const onConnect = async () => {
  if(connectStatus.value === "Cancel Connect"){      
    return await disConnectNetwork();
  } else {
    return await connectNetwork();
  }
};

//on menus selected
const handleSelect = (key: string, keyPath: string[]) => {
  activeIndex.value = key;

  tools.setUrlParamter('activeIndex', activeIndex.value);
};    

//login to wallet and switch to the target chain.
const login = async () => {
  await connectNetwork();
  connect.connectState.searchCallback();
};

//try get activeIndex from the url paramter
try{
  activeIndex.value = String(tools.getUrlParamter('activeIndex'));
  if(activeIndex.value != '1' && 
    activeIndex.value != '2' && 
    activeIndex.value != '3' && 
    activeIndex.value != '4' &&
    activeIndex.value != '5'){
    activeIndex.value = '1';
  }
}catch(e){
  activeIndex.value = '1';
}

//set activeIndex to connectState and location.href
connect.connectState.activeIndex.value = activeIndex.value;
tools.setUrlParamter('activeIndex', activeIndex.value);

//try connect to metamask
login();

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_search = _resolveComponent("search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_bell = _resolveComponent("bell")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { span: 2 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_image, {
              style: {"width":"35px","height":"33px","float":"right","margin-right":"10px","margin-top":"10px"},
              src: _unref(logo)
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 10 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu, {
            "default-active": _unref(activeIndex),
            class: "el-menu-demo",
            mode: "horizontal",
            ellipsis: false,
            "unique-opened": true,
            "background-color": "#606266",
            style: {"float":"left","width":"100%"},
            "text-color": "#fff",
            "active-text-color": "#ffd04b",
            onSelect: handleSelect
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "1" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "2" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "3" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "4" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "5" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["default-active"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 3 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            size: "large",
            modelValue: searchContent.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchContent).value = $event)),
            placeholder: "Search",
            style: {"margin-top":"10px"}
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, {
            circle: "",
            color: "#606266",
            size: "large",
            style: {"margin-top":"10px"},
            onClick: onSearchContent
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { size: 20 }, {
                default: _withCtx(() => [
                  _createVNode(_component_search)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 4 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_popover, {
            placement: "bottom-start",
            title: "Transactions",
            width: 200,
            trigger: "click"
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, {
                circle: "",
                color: "#606266",
                size: "large",
                style: {"margin-top":"10px","float":"right"},
                onClick: onClickNotify
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_badge, {
                    isDot: _unref(transactionCount)>0,
                    max: 99,
                    class: "item",
                    style: {"margin-top":"15px"},
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { size: 20 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_bell)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["isDot"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(transactions), (tx) => {
                    return (_openBlock(), _createBlock(_component_el_col, {
                      key: tx,
                      span: 20
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_link, {
                          type: "primary",
                          href: transactionExplorerUrl(tx),
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tools.shortString(tx)), 1)
                          ]),
                          _: 2
                        }, 1032, ["href"]),
                        _createVNode(_component_el_icon, {
                          onClick: ($event: any) => (onClickToCopy(tx)),
                          style: {"margin-left":"10px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_document_copy)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                style: {"float":"right"},
                onClick: onClearTransactions
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 3 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_popover, {
            placement: "bottom-start",
            title: networkName.value,
            width: 200,
            trigger: "hover"
          }, {
            reference: _withCtx(() => [
              (_unref(userName) != '')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (onClickToCopy(_unref(userName)))),
                    style: {"margin-top":"17px","padding-right":"10px","float":"right"}
                  }, _toDisplayString(_unref(shortName)), 1))
                : _createCommentVNode("", true),
              (_unref(userName) === '')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (onClickToCopy(_unref(userAddr)))),
                    style: {"margin-top":"17px","padding-right":"10px","float":"right"}
                  }, _toDisplayString(_unref(shortAddr)), 1))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              (_unref(userName) != '')
                ? (_openBlock(), _createBlock(_component_el_row, {
                    key: 0,
                    gutter: 20
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (onClickToCopy(_unref(userName)))),
                        style: {"margin-top":"17px"}
                      }, _toDisplayString(_unref(userName)), 1),
                      _hoisted_8
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_row, { gutter: 20 }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (onClickToCopy(_unref(userAddr)))),
                    style: {"margin-top":"17px"}
                  }, _toDisplayString(_unref(userAddr)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 1 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_dropdown, {
              button: "",
              trigger: "click",
              style: {"width":"35px","height":"33px","float":"right","margin-right":"20px","margin-top":"10px"}
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, {
                      onClick: onConnect,
                      innerText: connectStatus.value
                    }, null, 8, ["innerText"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_image, { src: _unref(metamask) }, null, 8, ["src"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})